import './navbar.css';
import { NavLink } from "react-router-dom";

interface Tab {path : string, header : string};

function Navbar( props : { tabs : Tab[] } ) {
    return <nav>
            {props.tabs.map( (tab) => <NavLink key={`tab_link_${tab.header}`} className={({ isActive }) => (isActive ? 'active' : 'inactive')} to={tab.path}>{tab.header}</NavLink>)}
        </nav>
  };
  
export default Navbar ;
export type { Tab };
